import { Skeleton } from "@mui/material";
import React, { useState } from "react";

export const ImageWithSkeleton = ({ src, alt, height, width, objectFit = "cover" }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      {!loaded && <Skeleton variant="rectangular" width={width == "fit-content" ? 200 : width} height={height} />}
      <img
        src={src}
        alt={alt}
        style={{
          width,
          height,
          objectFit: objectFit,
          display: loaded ? "block" : "none",
          background: "white"
        }}
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)} // Hide skeleton even if load fails
      />
    </>
  );
};
